import { Injectable, inject } from '@angular/core';

import { ClientConfigProductName, Page, StylesService, WebpackManifestService } from '@frontend/vanilla/core';

@Injectable({
    providedIn: 'root',
})
export class ProductStylesService {
    private page = inject(Page);
    private stylesService = inject(StylesService);
    private webpackManifestService = inject(WebpackManifestService);

    private alreadyLoaded: ClientConfigProductName[] = [];

    async tryLoad(product: ClientConfigProductName) {
        if (this.alreadyLoaded.includes(product)) {
            return;
        }

        let productStyleBundleKey = this.getProductStyleBundleKey(product);
        let productStylesBundleUrl = await this.webpackManifestService.getEntry(productStyleBundleKey);
        if (productStylesBundleUrl) {
            await this.stylesService.loadStyle({ url: productStylesBundleUrl, lazyLoad: 'Important' });
        }
        this.alreadyLoaded.push(product);
    }

    private getProductStyleBundleKey(product: ClientConfigProductName) {
        return `themes-${this.page.theme}-${product}.css`;
    }
}
